export default {"src":"/account/preferences/_next/static/media/TextMessaging.f9afe557.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};